<template>
    <div class="switch-btn">
        <div
            v-for="(item, index) in list"
            :key="index"
            class="switch-btn-item"
            @click="onClick(item.value)"
        >
            <div
                v-if="lightUp[index]"
                class="cube"
                :style="{ background: item.color }"
            ></div>
            <div v-else class="cube"></div>
            <div class="text">{{ item.text }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SwitchBtn',
    data() {
        return {}
    },
    props: {
        arrIndex: {
            type: Array,
            default: () => [],
        },
        list: {
            type: Array,
            default: function () {
                return [
                    {
                        text: '退租/空置',
                        color: '#F59B22',
                        value: '1',
                    },
                    {
                        text: '预定中',
                        color: '#00BFBF',
                        value: '2',
                    },
                    {
                        text: '租住中',
                        color: '#02A7F1',
                        value: '3',
                    },
                    {
                        text: '锁定中',
                        color: '#F4623B',
                        value: '5',
                    },
                ]
            },
        },
    },
    computed: {
        lightUp() {
            const list = []
            this.list.forEach((v, index) => {
                if (this.arrIndex.includes(v.value)) {
                    list.push(true)
                } else {
                    list.push(false)
                }
            })
            return list
        },
    },
    methods: {
        onClick(value) {
            this.$emit('on-click', value)
        },
    },
}
</script>

<style lang="less" scoped>
.switch-btn {
    display: flex;
    width: 300px;
    &-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        .cube {
            width: 16px;
            height: 16px;
            border-radius: 4px;
            background-color: #eee;
            margin-right: 8px;
        }
    }
    &-item + &-item {
        margin-left: 10px;
    }
}
</style>
